import React, { useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { ClockCounterClockwise, TShirt, UserCircle } from "@phosphor-icons/react";
import { Header } from "./shared";

const fmt = (iso) => {
  try {
    return new Date(iso).toLocaleString([], { month: "short", day: "numeric", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch { return iso; }
};

export default function ActivityLogTab() {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(() => {
    setLoading(true);
    api.get("/activity-log").then((r) => setLogs(r.data)).catch(() => {}).finally(() => setLoading(false));
  }, []);
  useEffect(() => { load(); }, [load]);

  return (
    <div data-testid="activity-log-tab">
      <Header title="Activity Log" />
      <p className="text-white/40 text-sm mb-6">A record of jersey number changes and other admin actions — who changed what, and when.</p>

      <div className="border border-white/10 bg-[#121212]" data-testid="activity-log-list">
        {loading && <p className="text-white/40 text-sm px-5 py-6">Loading activity…</p>}
        {!loading && logs.length === 0 && (
          <div className="flex flex-col items-center justify-center py-16 text-center">
            <ClockCounterClockwise size={40} className="text-white/20 mb-3" />
            <p className="text-white/40 text-sm">No activity yet. Jersey number changes will appear here.</p>
          </div>
        )}
        {logs.map((l) => (
          <div key={l.id} className="flex items-start gap-4 px-5 py-4 border-b border-white/5 last:border-0" data-testid="activity-log-row">
            <div className="w-9 h-9 shrink-0 bg-[#FF5722]/15 flex items-center justify-center">
              <TShirt size={18} className="text-[#FF5722]" />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm text-white/90">
                {l.player_name ? (
                  <>
                    <span className="font-semibold">{l.player_name}</span>
                    {l.team_name && <span className="text-white/40"> · {l.team_name}</span>}
                    {" — jersey "}
                    <span className="text-white/50 line-through">#{l.old_value}</span>
                    <span className="text-[#FF5722] font-bold"> → #{l.new_value}</span>
                  </>
                ) : (
                  l.message
                )}
              </div>
              <div className="flex items-center gap-3 mt-1.5 text-white/40 text-xs flex-wrap">
                <span className="flex items-center gap-1"><UserCircle size={13} /> {l.admin_name || l.admin_email || "Admin"}</span>
                <span>·</span>
                <span>{fmt(l.created_at)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
